<template>
    <div>
        <v-row>
            <v-col cols="5">
                <div>
                    <v-icon class="mdi mdi-magnify search-icon"/>
                    <input 
                        :placeholder="$store.getters.t('스트림명으로 검색')" 
                        v-model="search" 
                        class="search-input">
                </div>
            </v-col>

            <v-col class="text-right mb-2">
                <IconButton icon="mdi-autorenew" class="mr-2" @click="refresh" small />
                <!-- <IconButton icon="mdi mdi-download" class="mr-2" @click="download" small :loading="downloadLoading"/>
                <IconButton icon="mdi mdi-file-move-outline" class="mr-2" @click="moveTo" small :loading="moveLoading"/>
                <IconButton icon="mdi mdi-trash-can-outline" @click="deleteItem" small :loading="delLoading"/> -->
                <IconButtonTooltip :customCSS="'mr-2'" :disabled="this.sel.length === 0" :tooltipText="$store.getters.t('다운로드')" icon="mdi mdi-download" @click="download" small :loading="downloadLoading"/>
                <IconButtonTooltip :customCSS="'mr-2'" :disabled="this.sel.length === 0" :tooltipText="$store.getters.t('VOD관리로 이동')" icon="mdi mdi-file-move-outline" @click="moveTo" small :loading="moveLoading"/>
                <IconButtonTooltip  :disabled="this.sel.length === 0" :tooltipText="$store.getters.t('삭제')" icon="mdi mdi-trash-can-outline" @click="deleteItem" small :loading="delLoading"/>
            </v-col>


        </v-row>

        <Alert v-if="showAlert" :message="message" :message-type="messageType"></Alert>

        <v-data-table :headers="headers.recordHeaders" :items="recordList" :items-per-page="10"
            :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }" class="data-table"
            :disable-sort="true" show-select :search="search" :loading="loadingRefresh" v-model="sel" item-key="record_id"
            @input="enterSelect($event)">


            <template v-slot:item.displayStreamName="{ item }">
                {{ item.displayStreamName }}
            </template>

            <template v-slot:item.outputFilePath="{ item }">
                {{ item.outputFilePath }}
            </template>

            <template v-slot:item.lastModified="{ item }">
                {{ item.lastModified }}
            </template>

            <template v-slot:item.size="{ item }">
                {{ item.size }}
            </template>

        </v-data-table>


        <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />


    </div>
</template>

<script>
import WebRtcStreamApi from '@/api/webrtc/WebRtcStreamApi';
import Input from '@/components/ui/form/FormInput.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import SearchTextfield from '@/components/ui/form/SearchTextfield.vue';
import Alert from '@/components/app/AppAlert.vue';
import { mapGetters } from 'vuex';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import IconButtonTooltip from '@/components/ui/button/IconButtonTooltip.vue';
import { getDisplayStreamName } from '@/utils/streamName';

export default {
    components: {
        Input,
        TextButton,
        IconButton,
        SearchTextfield,
        Alert,
        AppSnackbar,
        IconButtonTooltip
    },
    data() {
        return {
            recordList: [],
            search: null,
            loadingRefresh: false,
            sel: [],
            message: null,
            messageType: null,
            showAlert: false,
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            snackbarErrorText: '',
            delLoading: false,
            downloadLoading: false,
            moveLoading: false,
        }
    },
    methods: {
        async getlist() {
            try {
                const ip = `${window.location.protocol}//${window.location.host}`;

                this.loadingRefresh = true;
                const data = {
                    ip: ip
                }
                const res = await WebRtcStreamApi.recordStreamApi(data);
                console.log("res => ", res.data)
                if (res.status === 1) {
                    this.recordList = (res.data || []).map(item => ({
                        ...item,
                        displayStreamName: getDisplayStreamName(item.stream_name_by_user, item.stream_name),
                    }));
                    this.loadingRefresh = false;
                }
            } catch (error) {
                console.error('[recording - getlist] error', error);
                this.loadingRefresh = false;
            }
        },
        enterSelect(val) {
            //console.log("체크값 확인 -> ", val);
        },
        refresh() {
            this.recordList = [];
            this.getlist();
        },
        async download() {
            try {
                if (this.sel.length === 0) {
                    this.snackbar = true;
                    this.snackbarError = true;
                    this.snackbarText = this.$store.getters.t("선택한 항목이 없습니다")
                    setTimeout(() => {
                        this.snackbarError = false;
                        this.snackbarText = ""
                        this.snackbar = false;
                        this.snackbarError = false;
                    }, 2000);
                }
                else {
                    this.downloadLoading = true;
                    const files = this.sel.map(e => e.stream_name + '+' + e.outputFilePath);
                    try {
                        for (const file of files) {
                            const data = {
                                params: { item: file },
                                responseType: 'blob'
                            }
                            const res = await WebRtcStreamApi.recordDownloadApi(data);
                            const url = window.URL.createObjectURL(new Blob([res]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', file);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                        this.snackbarText = this.$store.getters.t("다운로드 성공")
                        this.snackbar = true;
                        this.snackbarError = false;
  
                        setTimeout(() => {
                            this.snackbarText = ""
                            this.snackbar = false;
                            this.snackbarError = false;
                            this.downloadLoading = false;
                            this.sel = [];
                            this.refresh();
                        }, 2000);
                    } catch (error) {
                        console.error('[recording download] error :', error);

                        this.snackbarText = this.$store.getters.t("다운로드 실패")
                        this.snackbar = true;
                        this.snackbarError = true;
  
                        setTimeout(() => {
                            this.snackbarText = ""
                            this.snackbar = false;
                            this.snackbarError = false;
                            this.downloadLoading = false;
                            this.sel = [];
                            this.refresh();
                        }, 2000);
                    }
                }
            } catch (error) {
                console.error('[recording - download] error', error);
            }
        },
        async moveTo() {
            try {
                if (this.sel.length === 0) {
                    this.snackbar = true;
                    this.snackbarError = true;
                    this.snackbarText = this.$store.getters.t("선택한 항목이 없습니다")
                    setTimeout(() => {
                        this.snackbarError = false;
                        this.snackbarText = ""
                        this.snackbar = false;
                        this.snackbarError = false;
                    }, 2000);
                } else {
                    this.moveLoading = true;
                    const items = this.sel.map(e => e.stream_name + '+' + e.outputFilePath);
                    const res = await WebRtcStreamApi.recordMoveToApi(items);
                    // console.log("moveto res => ", res)
                    res.forEach(item => {
                        if(item.status == 1){
                            this.snackbar = true;
                            this.snackbarText = this.$store.getters.t('이동 성공');
                            this.snackbarError = false;
                        } else {
                            this.snackbar = true;
                            this.snackbarText = this.$store.getters.t('이동 실패');
                            this.snackbarError = true;
                        }
                    });
                 
                    setTimeout(() => {
                        this.snackbarText = ""
                        this.snackbar = false;
                        this.snackbarError = false;
                        this.moveLoading = false;
                        this.sel = [];
                        this.refresh();
                    }, 2000);
                }
            } catch (error) {
                console.error('[recording - moveTo] error', error);

                this.snackbarText = this.$store.getters.t('VOD관리로 이동 실패');
                this.snackbarError = true;
                this.snackbar = true;

                setTimeout(() => {
                    this.snackbarText = ""
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.moveLoading = false;
                    this.sel = [];
                    this.refresh();
                }, 2000);
            }
        },
        async deleteItem() {
            try {
                if (this.sel.length === 0) {
                    this.snackbar = true;
                    this.snackbarError = true;
                    this.snackbarText = this.$store.getters.t("선택한 항목이 없습니다")

                    setTimeout(() => {
                        this.snackbarError = false;
                        this.snackbarText = ""
                        this.snackbar = false;
                        this.snackbarError = false;
                    }, 2000);
                } else {
                    this.delLoading = true;
                    const items = this.sel.map(e => e.stream_name + '+' + e.outputFilePath);
                    // console.log("삭제 items => ", items)
                    // const frontUrl = `${window.location.protocol}//${window.location.host}`;
                    // const params = {
                    //     items: items,
                    //     ip: frontUrl
                    // }
                    const res = await WebRtcStreamApi.recordDeleteApi(items);
                    // console.log("삭제 res => ", res)
                    res.forEach(item => {
                        if (item.status === 1) {
                            this.snackbar = true;
                            this.snackbarText = this.$store.getters.t('삭제 성공');
                            this.snackbarError = false;
                        } else {
                            this.snackbar = true;
                            this.snackbarText = this.$store.getters.t('삭제 실패');
                            this.snackbarError = true;
                        }
                    });
                   
                    setTimeout(() =>{
                        this.snackbarError = false;
                        this.snackbar = false;
                        this.delLoading = false;
                        this.snackbarText = '';
                        this.sel = [];
                        this.refresh();
                    }, 2000);
                }
            } catch (error) {
                // console.error('삭제 error', error);
                this.snackbarText = this.$store.getters.t('삭제 실패');
                this.snackbarError = true;
                this.snackbar = true;

                setTimeout(() =>{
                    this.snackbarError = false;
                    this.snackbar = false;
                    this.delLoading = false;
                    this.snackbarText = '';
                    this.sel = [];
                    this.refresh();
                }, 2000);
            }
        },
    },
    computed: {
        ...mapGetters('objectData', ['getHeaders']),
        headers() {
            return {
                recordHeaders: this.getHeaders('recordWebRTCTable'),
            }
        },
    },
    beforeMount() {
        this.getlist();
    },
    mounted() {
        // this.wowzadbCheck();
    },
}
</script>

<style lang="scss" scoped>
.search-input {
    width: 70%;
    height: 36px;
    padding: 8px;
    margin-bottom: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background: #fff;
    padding-left: 36px;
}

.search-icon {
    position: absolute;
    margin-left: 10px;
    margin-top: 6px;
    color: #aaa;
}
</style>
